import React, { Component } from 'react';

import styles from './ThemeToggle.css'

function getInitialTheme() {
    try {
        var stored = localStorage.getItem('theme');
        if (stored === 'light' || stored === 'dark') return stored;
        var el = document.documentElement.getAttribute('data-theme');
        if (el === 'light' || el === 'dark') return el;
        var prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        return prefersDark ? 'dark' : 'light';
    } catch (e) {
        return 'light';
    }
}

class ThemeToggle extends Component {
    state = { theme: getInitialTheme() }

    componentDidMount() {
        // Ensure the DOM matches state (covers SSR-less first mount).
        document.documentElement.setAttribute('data-theme', this.state.theme);
    }

    toggle = () => {
        var next = this.state.theme === 'dark' ? 'light' : 'dark';
        this.setState({ theme: next });
        document.documentElement.setAttribute('data-theme', next);
        try { localStorage.setItem('theme', next); } catch (e) { /* ignore */ }
    }

    render() {
        var isDark = this.state.theme === 'dark';
        return (
            <button
                type="button"
                className={styles['theme-toggle']}
                onClick={this.toggle}
                aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
                title={isDark ? 'light' : 'dark'}
            >
                {isDark ? (
                    /* sun */
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none"
                         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="4" />
                        <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" />
                    </svg>
                ) : (
                    /* moon */
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none"
                         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
                    </svg>
                )}
            </button>
        )
    }
}

export default ThemeToggle;
